import { render, staticRenderFns } from "./TwoColumns.vue?vue&type=template&id=05c8d5e7"
import script from "./TwoColumns.vue?vue&type=script&lang=js"
export * from "./TwoColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c8d5e7')) {
      api.createRecord('05c8d5e7', component.options)
    } else {
      api.reload('05c8d5e7', component.options)
    }
    module.hot.accept("./TwoColumns.vue?vue&type=template&id=05c8d5e7", function () {
      api.rerender('05c8d5e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/TwoColumns.vue"
export default component.exports